import { render, staticRenderFns } from "./QuoteDetailView.vue?vue&type=template&id=fbfb7ba2"
import script from "./QuoteDetailView.vue?vue&type=script&lang=js"
export * from "./QuoteDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports